import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import SharedFolderList from './SharedFolderList';

const SharedFolders = () => {
  return renderComponent(<SharedFolderList />);
};

export default SharedFolders;
